export default __webpack_public_path__ + "static/media/savebutton.002ee631.svg";